import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from 'lang/en.json';
import kn from 'lang/kn.json';

i18n
    .use(initReactI18next)
    .init({
        resources: {
            en: { translation: en },
            kn: { translation: kn },
        },
        lng: 'en', // default
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false
        }
    });

export default i18n;
